import {FlowBlock, FlowSize} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {FlowUtil} from '@mintdata-wsp/common/util/FlowUtil';
import {FlowWiresController} from '@mintdata-wsp/wsp/controllers/visualDesigner/workbench/flow/FlowWiresController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import {action, observable, reaction} from 'mobx';

export class FlowCanvasExtentManager
{
    @observable
    private _canvasExtent:FlowSize = null;
    private _canvasViewportSize:FlowSize = null;

    @bind
    public init():void
    {
        window.addEventListener('resize', (e) =>
        {
            this._tryMeasureCanvasBounds();
            this.applyCanvasExtent();
        });

        this._tryMeasureCanvasBounds();
        this._listenForSvgElementResize();
    }

    @bind
    public applyCanvasExtent():void
    {
        // TODO: remove
        // return;

        const canvasExtent = this._computeFlowCanvasExtent();

        if( canvasExtent )
        {
            if( !this._canvasViewportSize )
                this._tryMeasureCanvasBounds();

            if( !this._canvasViewportSize )
                return;

            let neededWidth:number;
            if( canvasExtent.width > this._canvasViewportSize.width )
                neededWidth = canvasExtent.width;
            else
                neededWidth = this._canvasViewportSize.width;

            let neededHeight:number;
            if( canvasExtent.height > this._canvasViewportSize.height )
                neededHeight = canvasExtent.height;
            else
                neededHeight = this._canvasViewportSize.height;

            this._setExtent(neededWidth, neededHeight);
        }
    }

    @bind
    private _listenForSvgElementResize():void
    {
        reaction(() =>
            {
                return this._canvasExtent;
            },
            () =>
            {
                const controller = controllers.ui.flowCanvas;
                const wiresSvgElement = controller.getWiresSvgElement();
                if( !wiresSvgElement )
                    return;

                const extent = this._canvasExtent;

                wiresSvgElement.style.width = `${extent.width}px`;
                wiresSvgElement.style.height = `${extent.height}px`;
            });
    }

    @bind
    private _tryMeasureCanvasBounds():void
    {
        const controller = controllers.ui.flowCanvas;
        const canvasElement = controller.getCanvasDomElement();

        if( canvasElement )
        {
            const rect = canvasElement.getBoundingClientRect();

            this._canvasViewportSize = new FlowSize(rect.width, rect.height);
        }
    }

    @action.bound
    private _setExtent(neededWidth:number, neededHeight:number):void
    {
        this._canvasExtent = new FlowSize(neededWidth, neededHeight);
    }

    private _computeFlowCanvasExtent():FlowSize | null
    {
        const controller = controllers.ui.flowCanvas;
        const blocks = controller.getCurrentFlowBlocks();
        if( !blocks )
            return null;

        let maxWidth = 0;
        let maxHeight = 0;

        blocks.map((b:FlowBlock) =>
        {
            const w = b.bounds.position.x + b.bounds.size.width;
            if( w > maxWidth )
                maxWidth = w;

            const h = b.bounds.position.y + b.bounds.size.height;
            if( h > maxHeight )
                maxHeight = h;
        });

        maxWidth += FlowWiresController.MIN_HORIZONTAL_PX_FOR_RTL_FLOW / 2 + FlowUtil.WIRE_THICKNESS * 4;

        return new FlowSize(maxWidth, maxHeight);
    }
}
